import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalTitle,
} from '@cambridgeassessment/cambridge-ui';
import { Box, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import useOrgUserDetails from 'src/hooks/useOrgUserDetails';
import { useStyles } from './styles';
import { getFullName } from './utils';

const DisableUser: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  const { disableUser, userDetails } = useOrgUserDetails();
  const name = getFullName(userDetails.firstName, userDetails.lastName);

  const openModal = () => {
    setOpen(true);
  };
  const closeModal = () => {
    setOpen(false);
  };

  const classes = useStyles();

  return (
    <>
      <Button
        variant="outlined"
        style={{ color: '#00588f' }}
        onClick={openModal}
        data-testid="open-confirmation-modal"
      >
        Disable user
      </Button>

      <Modal
        open={open}
        size="small"
        onClose={closeModal}
        data-testid="confirmation-modal"
      >
        <Box className={classes.modalTitle}>
          <ModalTitle onClose={closeModal} data-testid="confirmation-header">
            {`Disable ${name}?`}
          </ModalTitle>
        </Box>
        <ModalContent>
          <Typography
            variant="body1"
            className={classes.modalText}
            data-testid="confirmation-body"
          >
            Are you sure that you want to disable{' '}
            {name === 'user' ? name : <strong>{name}</strong>}?
            <br />
            <br />
            They will not have access to the services your organisation
            subscribes to but they will still have their Cambridge account for
            managing their own personal details.
          </Typography>
        </ModalContent>
        <ModalActions>
          <Button
            onClick={closeModal}
            color="primary"
            variant="text"
            data-testid="cancel-confirmation-modal"
          >
            Cancel
          </Button>
          <Button
            onClick={disableUser}
            color="primary"
            data-testid="confirm-confirmation-modal"
          >
            Disable user
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};
export default DisableUser;
